// Корневой компонент с роутингом.
// FTUE (Welcome / Reward / Battle / NFT / Tour) удалён в Этапе 46.17 —
// будет переписан с нуля.

import { Routes, Route, Navigate } from 'react-router-dom';
import { HomeScreen } from './screens/HomeScreen';
import { ProfileScreen } from './screens/ProfileScreen';
import { ArchiveScreen } from './screens/ArchiveScreen';
import { MatchDetailScreen } from './screens/MatchDetailScreen';
import { ReplayScreen } from './screens/ReplayScreen';
import {
  FriendsScreen, AchievementsScreen, ReferralsScreen, InventoryScreen
} from './screens/ProfileTileScreens';
import {
  RatingScreen, ShopScreen, QuestsScreen, BPScreen
} from './screens/MainScreens';
import {
  DecksScreen, HeroPickScreen, ShopCosmeticScreen
} from './screens/DecksScreens';
import { DeckEditorScreen } from './screens/DeckEditorScreen';
import { FriendProfileScreen } from './screens/FriendProfileScreen';
import { PvpScreen } from './screens/PvpScreen';
import { MarketplaceScreen } from './screens/MarketplaceScreen';
import { MatchmakingScreen } from './screens/MatchmakingScreen';
import { BattleScreen } from './screens/BattleScreen';
import { SandboxScreen } from './screens/SandboxScreen';
import { ColyseusTestScreen } from './screens/ColyseusTestScreen';
import { TutorialBattleScreen } from './screens/TutorialBattleScreen';
import { DailyLoginScreen } from './screens/DailyLoginScreen';
import { StudyOverlay } from './study/StudyOverlay';
import { ToastHost } from './components/Toast';
import { DeletionWarning } from './components/DeletionWarning';
import { ReferrerOnboarding } from './components/ReferrerOnboarding';
import { NickSetupModal } from './components/NickSetupModal';
import { PreFTUE } from './components/PreFTUE/PreFTUE';
import { TutorialOverlay } from './tutorial/Tutorial';
import { TutorialDemo } from './tutorial/TutorialDemo';
import { TransitionOverlay, AutoIncomingListener } from './transitions';
import { useGameStore } from './store/useGameStore';
import { MenuMusic } from './audio/MenuMusic';

export default function App() {
  // ФТУЕ.1: во время Pre-FTUE отключаем legacy-модалки (NickSetupModal +
  // ReferrerOnboarding), потому что их роль теперь выполняют шаги PreFTUE.
  const ftueStatus = useGameStore(g => g.ftueStatus);
  const inFtue = ftueStatus === 'pending' || ftueStatus === 'in_progress';

  return (
    <>
    <DeletionWarning />
    <PreFTUE />
    {!inFtue && <NickSetupModal />}
    {!inFtue && <ReferrerOnboarding />}
    <StudyOverlay />
    {/* ФТУЕ.2: оверлей-движок туториала (spotlight/coach/hand/progress).
        Сам не активен — ждёт пока сценарий вызовет useTutorialStore.start(). */}
    <TutorialOverlay />
    <ToastHost />
    {/* АНИМ.1: глитч-переходы между экранами.
        TransitionOverlay рисует middle-кадр + pixel-sort bars (portal в body).
        AutoIncomingListener даёт fade-in эффект на любых legacy useNavigate. */}
    <TransitionOverlay />
    <AutoIncomingListener />
    {/* Этап 63: фоновая музыка меню. Играет везде кроме боя, по тоглу «Музыка»,
        старт после первого жеста, глушится в фоне. */}
    <MenuMusic />
    <Routes>
      <Route path="/"        element={<Navigate to="/home" replace />} />
      <Route path="/home"    element={<HomeScreen />} />
      <Route path="/profile" element={<ProfileScreen />} />

      <Route path="/archive"        element={<ArchiveScreen />} />
      <Route path="/match/:id"      element={<MatchDetailScreen />} />
      <Route path="/replay/:id"     element={<ReplayScreen />} />
      <Route path="/friends"        element={<FriendsScreen />} />
      <Route path="/player/:id"     element={<FriendProfileScreen />} />
      <Route path="/achievements"   element={<AchievementsScreen />} />
      <Route path="/referrals"      element={<ReferralsScreen />} />
      <Route path="/inventory"      element={<InventoryScreen />} />

      <Route path="/shop"           element={<ShopScreen />} />
      <Route path="/quests"         element={<QuestsScreen />} />
      <Route path="/bp"             element={<BPScreen />} />
      <Route path="/rating"         element={<RatingScreen />} />

      {/* МАР: внутриигровой маркетплейс карт (Этап 56) */}
      <Route path="/marketplace"    element={<MarketplaceScreen />} />

      <Route path="/pvp"            element={<PvpScreen />} />
      <Route path="/pvp/match"      element={<MatchmakingScreen />} />
      <Route path="/battle"         element={<BattleScreen />} />
      {/* Dev-полигон: не в меню, доступен только по URL /sandbox.
          Для тестов карт — контроль обеих сторон + библиотека всех карт. */}
      <Route path="/sandbox"        element={<SandboxScreen />} />
      {/* ПвП.5: тестовый экран Colyseus PvP. Открыть в 2 браузерах
          (или 2 окнах инкогнито) — должны встретиться в одной комнате. */}
      <Route path="/colyseus-test"  element={<ColyseusTestScreen />} />
      {/* ПвП.6.1: PvP идёт через тот же BattleScreen что и PvE, с
          location.state.pvpMode=true. BattleScreen берёт комнату из
          pvp/client.getCurrentRoom() и заменяет локальный движок
          подпиской на server-state через engine-shim. */}
      <Route path="/pvp/battle"     element={<BattleScreen />} />
      {/* ФТУЕ.2: dev-демо туториал-оверлея, доступ по URL /tutorial-demo. */}
      <Route path="/tutorial-demo"  element={<TutorialDemo />} />
      {/* ФТУЕ.3 (placeholder): сюда переходит игрок после "Да" в Pre-FTUE.
          Сейчас — заглушка с кнопкой завершения. Реальный туториал-бой —
          следующий этап. */}
      <Route path="/tutorial-battle" element={<TutorialBattleScreen />} />

      <Route path="/daily-login"    element={<DailyLoginScreen />} />
      <Route path="/shop/cosmetic"  element={<ShopCosmeticScreen />} />
      <Route path="/decks"          element={<DecksScreen />} />
      <Route path="/decks/pick"     element={<HeroPickScreen />} />
      <Route path="/decks/editor"   element={<DeckEditorScreen />} />

      <Route path="*" element={<Navigate to="/home" replace />} />
    </Routes>
    </>
  );
}
